export const GET_EQUIPMENTS = 'GET_EQUIPMENTS';
export const ERROR_SERVER = 'ERROR_SERVER';
export const SET_ACCESS_EQUIPMENTS_SELECTED = 'SET_ACCESS_EQUIPMENTS_SELECTED';
export const SET_ACCESS_EQUIPMENT = 'SET_ACCESS_EQUIPMENT';
export const CLEAN = 'CLEAN';